import { initializeGTM } from './init';
import React from 'react';

const gtmHoc = (WrappedComponent: React.FunctionComponent) => () => {
  initializeGTM();

  return <WrappedComponent />;
};

export default gtmHoc;
